import {
    Component,
    AfterViewInit,
    ElementRef,
    OnDestroy,
    ViewEncapsulation,
    Renderer2
} from '@angular/core'
import {ConfigService} from "../../services/configService";
import {Configuration} from "../../objects/common/configuration";

declare let Redoc: any;

@Component({
    selector: 'api-documentation',
    templateUrl: './api-documentation.component.html',
    styleUrls: ['./api-documentation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    moduleId: module.id.toString()
})
export class ApiDocumentationComponent implements AfterViewInit, OnDestroy {
    protected config: Configuration;
    public currentYear: string;

    constructor(private element: ElementRef, private renderer: Renderer2, private configService: ConfigService) {
        this.config = configService.config;
        this.currentYear = new Date().getFullYear().toString();
    }

    ngAfterViewInit() {

        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");

        this.attachDocumentationComponent()
    }

    async attachDocumentationComponent() {
        const elem = this.element.nativeElement.querySelector('.documentation-root');

        Redoc.init(`${this.config.ApiUrl}/swagger/v1/swagger.json`, {}, elem)
    }

    ngOnDestroy(): void {
        this.element.nativeElement.querySelector('.documentation-root').remove()
    }
}



// WEBPACK FOOTER //
// ./app/components/api-documentation/api-documentation.component.ts